import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../authConfig';

const PrivateRoute = () => {
    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
        >
            <Outlet />
        </MsalAuthenticationTemplate>
    );
};

export default PrivateRoute;